import axios from 'axios';
import { accountLinkingConstants } from '../constants';
import { AUTH_USER_TYPES } from '../constants/auth.constants';
import { loadAuthSession, pickAccessToken, pickTenantApiToken, stripBearer } from '../helpers/authStorage.helper';
const qs = require('qs');

let accept = "";

const setHeader = (headers, key, value) => {
    if (!headers) return;
    if (typeof headers.set === "function") {
        headers.set(key, value);
        return;
    }
    headers[key] = value;
};

axios.interceptors.request.use((config) => {
    const url = String(config.url || "");
    const isAuthCall = /\/auth\/login|\/system\/auth\/login|\/auth\/logout|\/system\/auth\/logout/i.test(url);
    if (isAuthCall) {
        return config;
    }

    const session = loadAuthSession();
    if (!session?.loggedIn) {
        return config;
    }

    config.headers = config.headers || {};
    const isSystemSession = session.userType === AUTH_USER_TYPES.SYSTEM;
    const isTenantIdpApi =
        /\/api\/identity\/v1\//i.test(url) &&
        !/\/system\//i.test(url);
    const token = stripBearer(
        isTenantIdpApi && !isSystemSession
            ? pickTenantApiToken(session.user || {})
            : pickAccessToken(session.user || {})
    );
    const requestTenantId = session.activeTenantId || session.tenantId;

    if (isTenantIdpApi && !isSystemSession) {
        const explicitTenantId =
            (typeof config.headers?.get === "function"
                ? config.headers.get("tenantId")
                : config.headers?.tenantId) || requestTenantId;

        if (typeof config.headers?.clear === "function") {
            config.headers.clear();
        } else {
            config.headers = {};
        }

        if (token) {
            setHeader(config.headers, "Authorization", `Bearer ${token}`);
        }
        if (explicitTenantId) {
            setHeader(config.headers, "tenantId", String(explicitTenantId).toLowerCase());
        }
        return config;
    }

    if (token) {
        setHeader(config.headers, "x-auth-token", token);
        setHeader(config.headers, "Authorization", `Bearer ${token}`);
        setHeader(config.headers, "authorization", `Bearer ${token}`);
    }
    if (requestTenantId) {
        const tenantIdValue = String(requestTenantId).toLowerCase();
        setHeader(config.headers, "tenantId", tenantIdValue);
        setHeader(config.headers, "TenantId", tenantIdValue);
    }
    return config;
});

const sanitizeParams = (params) => {
    return params;
  }

const getHeaders = (headerObj = {}) => {
    let headers = {
        Accept: accept,
    };

    if (!headerObj['Content-Type'] && !headerObj['multipart/form-data'] && !headerObj.skipJsonContentType) {
        headers['Content-Type'] = 'application/json';
    }

    delete headerObj['multipart/form-data'];
    delete headerObj.skipJsonContentType;

    return {
        ...headers,
        ...headerObj
    };
}

const makeRequest = async (path, key = "api_call", reqInit, options = {}) => {
    const headers = getHeaders(options?.headers || {});
    const init = Object.assign({}, reqInit, { headers });

    return await axios({
        url: path,
        ...init,
        timeout: 30000,
    })
        .then(res => res)
        .catch((err) => {
            if (key === accountLinkingConstants.API_KEY) {
                return err?.response;
            }

            if (err && !err.response) {
                err = {
                    response: {
                        error: err,
                        status: 503
                    }
                };
            } else if (err?.response) {
                err.response["error"] = err?.response?.data;
                delete err?.response?.data;
            }

            return err?.response;
        });
}

const getParams = (queryParams = {}) => {
    return queryParams;
}

const get = async (path, key, queryParams, body = {}, options = {}) => {
    const getData = {
        method: 'GET',
        params: getParams(queryParams),
        paramsSerializer: (params) => {
            return qs.stringify(sanitizeParams(params), { arrayFormat: 'brackets' });
        },
    };
    if (body && Object.keys(body).length) {
        getData.data = { ...body };
    }
    return await makeRequest(path, key, getData, options)
}

const post = async (path, key, body, options = {}) => {
    const postData = {
        method: 'POST',
        data: { ...body },
        ...options
    };

    return await makeRequest(path, key, postData, options);
}

const put = async (path, key, body, options = {}) => {
    const putData = {
        method: 'PUT',
        data: { ...body },
        ...options
    };

    return await makeRequest(path, key, putData, options);
}

const del = async (path, key, body = {}, options = {}) => {
    const deleteData = {
        method: 'DELETE',
        data: { ...body },
        ...options
    };

    return await makeRequest(path, key, deleteData, options);
}

export const API = {
    post,
    get,
    put,
    delete: del,
}
